import styled from "@emotion/styled";

export const Anchor = styled.a`
  display: block;
  position: relative;
  top: -32px;
  visibility: hidden;
`;
